import Vue from 'vue'

Vue.filter('dayjs', function (val, format) {
  if (val) {
    return window.dayjs(String(val)).format(format)
  }
})
